import { render, staticRenderFns } from "./DefinitionActions.vue?vue&type=template&id=71cea6e6&"
import script from "./DefinitionActions.vue?vue&type=script&lang=ts&"
export * from "./DefinitionActions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports